import { inject, Injectable } from '@angular/core';
import { CanMatch } from '@angular/router';

import { AuthTokenService } from '@core/services/auth-token.service';

@Injectable({ providedIn: 'root' })
export class AnonymousGuard implements CanMatch {
  private readonly authTokenService = inject(AuthTokenService);

  canMatch(): boolean {
    const token = this.authTokenService.getTokenData();

    if (!token) {
      this.authTokenService.deleteAll();
      return true;
    }

    if (this.authTokenService.isTokenExpired()) {
      this.authTokenService.deleteAll();
      return true;
    }

    return false;
  }
}
